<template>
    <section class="questionwrapper">
      <div class="helper-holder">
        <p><span class="largetext"><span class="colorlight">[</span>{{ answerFourC.title }}<span class="colorlight">]</span></span></p>
        <p>can in short be explained as:</p>
        <p class="smalltext">{{ answerFourC.extract }}</p>
      </div>
    </section>
</template>

<script>
export default {
  props: {
    answerFourC: {
      type: Object
    }
  }
};
</script>

<style>

</style>
